class InfiniteScrolling extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.currentPage = 1;
    this.hasNextPage = true;

    this.selectors = {
      grid: '.product-grid',
      product: '.product-item',
      button: '[show-more-button]',
      pagination: '.pagination',
      nextButton: '.pagination__item--next'
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.productGrid = document.querySelector(this.selectors.grid);
    this.infiniteButton = this.querySelector(this.selectors.button);

    if (!this.productGrid || !this.infiniteButton) return;

    this.currentPage = parseInt(this.productGrid.dataset.currentPage) || 1;
    this.totalPages = parseInt(this.productGrid.dataset.totalPages) || 1;
    this.hasNextPage = this.totalPages > this.currentPage;

    this.infiniteButton.addEventListener('click', () => this.loadNextPage());

    if (!this.hasNextPage) this.infiniteButton.hidden = true;
  }

  async loadNextPage() {
    if (this.isLoading || !this.hasNextPage) return;

    this.isLoading = true;
    this.updateButtonState(true);

    try {
      const nextPage = this.currentPage + 1;

      const fetchUrl = new URL(window.location.href);
      fetchUrl.searchParams.set('page', nextPage);

      const response = await fetch(fetchUrl.toString());
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('.product-item');

      if (newProducts.length > 0) {
        this.renderProducts(newProducts, nextPage);

        this.currentPage = nextPage;
        this.productGrid.dataset.currentPage = nextPage;
        this.hasNextPage = this.totalPages > nextPage;
      } else {
        this.hasNextPage = false;
      }
    } catch (error) {
      console.error('Error loading next page:', error);
    } finally {
      this.isLoading = false;
      this.updateButtonState(false);
      if (!this.hasNextPage) this.infiniteButton.hidden = true;
    }
  }

  renderProducts(products, page) {
    const fragment = document.createDocumentFragment();
    let firstNewProduct = null;

    products.forEach((product, index) => {
      const node = product.cloneNode(true);
      node.dataset.page = page;
      fragment.appendChild(node);
      if (index === 0) firstNewProduct = node;
    });

    this.productGrid.appendChild(fragment);

    if (window.customElements && customElements.get('icon-wrapper')) {
      const iconWrappers = this.productGrid.querySelectorAll('icon-wrapper');
      iconWrappers.forEach((iconWrapper) => {
        if (typeof iconWrapper._init === 'function') {
          iconWrapper._init();
        }
      });
    }

    requestAnimationFrame(() => {
      if (typeof ScrollTrigger !== 'undefined' && typeof ScrollTrigger.refresh === 'function') {
        ScrollTrigger.refresh();
      }
      if (firstNewProduct) {
        this._focusFirstLoadedProduct(firstNewProduct);
      }
    });
  }

  _focusFirstLoadedProduct(item) {
    if (!item) return;

    let focusTarget = null;

    if (typeof theme !== 'undefined' && theme.getFocusableElements) {
      const candidates = theme
        .getFocusableElements(item)
        .filter(
          (el) =>
            !el.classList.contains('hidden') && el.getAttribute('aria-disabled') !== 'true'
        );
      focusTarget = candidates[0] || null;
    }

    if (!focusTarget) {
      if (!item.hasAttribute('tabindex')) {
        item.setAttribute('tabindex', '-1');
      }
      focusTarget = item;
    }

    focusTarget?.focus?.({ preventScroll: false });
  }

  updateButtonState(loading) {
    this.infiniteButton.classList.toggle('loading', loading);
    this.infiniteButton.querySelector('.loading__spinner').classList.toggle('hidden', !loading);
    this.infiniteButton.disabled = loading;
  }
}
customElements.define('infinite-scrolling', InfiniteScrolling);